import { useCallback, useEffect, useState } from "react";
const BASEURL = process.env.REACT_APP_BASE_URL;
const useTspwardData = ({city, toDate, wardNumber}:{city:string, toDate:string, wardNumber: string}) => {

  const [tspwardData, settspwardData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>();
  
  useEffect(() => {
    let didCancel = false;
    setError(null);

    (async () => {
      try {
        setLoading(true);
       
        const response = await fetch(
          `${BASEURL}/v1/insights/tsp-wardwisedetail?wardNumber=${wardNumber}&city=${city}&date=${toDate}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const result = await response.json();
        console.log("result", result);
        // const wards = Object.keys(result.data.clusterList);
        // // console.log("wards", wards)
        // const propertiesInfo = wards.map((index) => {
        //     // return  {wardNo : result.data.clusterList[index].wardNo, totalClustersAvailable: result.data.clusterList[index].totalClustur, totalScannedClusters:Math.round(result.data.clusterList[index].totalScannedClusters/ dayDiff) , totalUnscannedClusters:Math.round(result.data.clusterList[index].totalClustur - Math.round(result.data.clusterList[index].totalScannedClusters/dayDiff)) , clusterScanningPercent: (100 * Math.round(result.data.clusterList[index].totalScannedClusters/ dayDiff) / result.data.clusterList[index].totalClustur).toFixed(2) };
        //     return  {wardNo : result.data.clusterList[index].wardNo, totalClustersAvailable: result.data.clusterList[index].totalClustur, totalScannedClusters:Math.round(result.data.clusterList[index].totalScannedClusters) , totalUnscannedClusters:result.data.clusterList[index].totalUnscannedClusters , clusterScanningPercent: Math.round(result.data.clusterList[index].clusterScanningPercent).toFixed(2) };
        //   });
          
        settspwardData(result.data);
        
        if (!didCancel) {
      
          didCancel =true
          }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    })();

    return () => {
      didCancel = true;
    };
  }, [city, toDate, wardNumber]);
 
  return {  tspwardData, loading };
};

export default useTspwardData;
